import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { ProjectManagementSettings } from "@/data/models/Settings";
import { createDefaultProjectManagementSettings } from "@/data/models/Client";

const name = "projectManagementSettings";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class ProjectManagementSettingsVuexModule extends VuexModule {
  projectManagementSettings: ProjectManagementSettings = createDefaultProjectManagementSettings();

  /**
   * Whether the client's project management settings has been read from Firestore yet, or found missing.
   *
   * The defaults above are indistinguishable from a real document, and the observer that replaces
   * them is wired up in `Scaffold`, which mounts only after `router.beforeEach` resolves. The route
   * guard therefore loads it once itself and needs to know whether that has happened.
   */
  hasLoaded = false;

  @Mutation
  setProjectManagementSettings(projectManagementSettings: ProjectManagementSettings) {
    this.projectManagementSettings = projectManagementSettings;
    this.hasLoaded = true;
  }

  /** Records that the document was read and does not exist, so the defaults are the real state. */
  @Mutation
  markLoaded() {
    this.hasLoaded = true;
  }

  @Mutation
  clear() {
    this.projectManagementSettings = createDefaultProjectManagementSettings();
    this.hasLoaded = false;
  }
}

export const ProjectManagementSettingsModule = getModule(ProjectManagementSettingsVuexModule, store);
